module.exports = __webpack_public_path__ + "img/图纸.f77c8245.png";